export const BIG_FRAME_W = 4000;
